module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "onepager-container offerte",
    class: _vm.environment
  }, [_vm._l((_vm.onepagers), function(onepager) {
    return _c('onepager', {
      key: onepager.type,
      attrs: {
        "environment": _vm.environment,
        "logo": _vm.logo,
        "multiRowPath": onepager.multiRowPath,
        "products": onepager.products,
        "tableConfig": onepager.tableConfig,
        "template": _vm.getTemplateManager(onepager.template),
        "type": onepager.type
      }
    })
  }), _vm._v(" "), (_vm.environment === 'hanvb' && _vm.onepagers.length > 0) ? _c('document-container', {
    attrs: {
      "body": _vm.appendBody,
      "footer": _vm.appendFooter,
      "header": _vm.appendHeader,
      "logo": _vm.logo,
      "documentType": "onepager"
    }
  }) : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-56039f9a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/offerte/Offerte.vue
// module id = 684
// module chunks = 0